<template>
  <div class="my-schedule m-3">
    <schedule :doctor-id="authUser.id"></schedule>
  </div>
</template>
<script>
import Schedule from '@/components/Schedule/Schedule'
import { mapGetters } from 'vuex'
export default {
  components: {
    Schedule
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user'
    })
  }
}
</script>
